<template>
    <div class="qty form-group row no-gutters">
        <label v-if="hasLabel" class="col-5 col-lg-4 col-form-label">Quantité </label>
        <div :class="hasLabel ? 'col-7 col-lg-8' : 'col-12 col-lg-12'">
            <button :type="buttonType" @click="--quantity" class="btn btn-default float-left">-</button>
            <input type="number" v-model="quantity" class="form-control float-left" placeholder="1">
            <button :type="buttonType" @click="++quantity" class="btn btn-default float-left">+</button>
        </div>
    </div>
</template>

<style scoped>
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>

<script>

    import {mapActions, mapState} from 'vuex';
    import store from '../store';

    const CartQuantity = {
        name: 'ponroy-cart-quantity',
        store,
        props: {
          value: {
              type: Number,
          },
          buttonType: {
              type: String,
              default: 'submit'
          },
            hasLabel: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                quantity: this.value,
            };
        },
        watch: {
            value(value) {
              this.quantity = value;
            },
            quantity(val, oldVal) {
                val = Number(val);

                if (isNaN(val)) {
                    val = oldVal;
                }

                if (val < 1) {
                    val = 1;
                }

                this.$emit('input', val);

                this.quantity = val;
            },
        }
    };

    export default CartQuantity;

</script>


// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartQuantity.vue